import { useState } from 'react';

import { useListBackerConsumerWallet } from '@givebacks/api/backer';
import { useBreakPoints } from 'core';
import { ButtonMantine, Group, Skeleton, Stack, Title } from 'ui';
import { randomId } from 'ui/Hooks';

import { ConsumerExpiredWalletModal } from './ConsumerExpiredWalletModal';
import classes from './ConsumerWallet.module.css';
import { ConsumerWalletListCard } from '../../Account/components/ConsumerWalletCard/ConsumerWalletListCard';

const ConsumerWallet = () => {
  const [showExpired, setShowExpired] = useState(false);
  const { data: backerWalletCards, isLoading } = useListBackerConsumerWallet();
  const { isSmallScreen } = useBreakPoints();
  const { data: walletExpiredCards } = useListBackerConsumerWallet({ expired: true });

  return (
    <>
      <Stack>
        <Group justify="space-between">
          <Title order={2}>Wallet</Title>
          {walletExpiredCards?.length && (
            <ButtonMantine
              variant="subtle"
              onClick={() => setShowExpired(true)}
              size={isSmallScreen ? 'xs' : 'sm'}
            >
              View Expired
            </ButtonMantine>
          )}
        </Group>
        <Skeleton visible={isLoading}>
          <Stack gap={0} className={classes.ConsumerWalletCard}>
            {backerWalletCards?.map((card) => (
              <ConsumerWalletListCard walletCard={card} key={randomId()} />
            ))}
          </Stack>
        </Skeleton>
      </Stack>
      <ConsumerExpiredWalletModal
        opened={showExpired == true}
        onClose={() => setShowExpired(false)}
      />
    </>
  );
};

export { ConsumerWallet };
